/* tslint:disable */
import { Question } from "./Question"

export class RespondAnswer {
		Id: number;
		RespondId: number;
		QuestionId: number;
		Answer: string;

		Question: Question;
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/RespondAnswer.ts